<template>
  <div>
    <ul uk-tab class="uk-iconnav">
      <li v-for="tab in tabs" :class="{ 'uk-active': tab.isActive }" :key="tab.name">
        <a href="#" :data-uk-icon="'icon:' + tab.icon" :title="tab.tooltip" data-uk-tooltip @click.prevent="selectTab(tab)"></a>
      </li>
    </ul>

    <ul class="uk-switcher uk-margin">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: []
    };
  },

  mounted() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      //this.$router.push({ hash: selectedTab.name })
      this.tabs.forEach(tab => {
        tab.isActive = tab.href == selectedTab.href;
      });
    }
  }
};
</script>
